export default __webpack_public_path__ + "static/media/woodart.5eb84341.webp";